import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const blush: Collection = {
  id: 's-and-p-blush',
  brandId: 'salt-and-pepper',
  brandName: 'Salt and Pepper',
  icon: 'logo_salt_pepper.png',
  title: 'Blush',
  subTitle: 'Speels en kleurrijk',
  banner: 'blush/blush_banner.jpg',
  items: [
    {
      id: 's-and-p-blush-1',
      collectionImages: [
        {
          image: 'blush/Blush.jpg',
          width: CollectionBannerWidth['25%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'blush/Blush_7.jpg',
          width: CollectionBannerWidth['75%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 's-and-p-blush-2',
      collectionImages: [
        {
          image: 'blush/Blush_9.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'blush/Blush_8.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 's-and-p-blush-3',
      collectionImages: [
        {
          image: 'blush/Blush_2.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'blush/Blush_3.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'blush/Blush_5.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        }
      ]
    }
  ],
  salesArticleIds: [
    '02fe0d7f-dfeb-4529-b66c-f4b7305d2de9',
    '6e6615d1-c001-4ee9-b653-d9ead4e93b1e',
    'db3f2d8e-52e0-4894-b571-8d6a7f5ee8a3',
    '3742c4ac-8738-4829-b162-f496f1d8c21b',
    'f96ac254-d89b-4db7-8b58-626a28805e35',
    'f8a25492-a4b2-4c99-a1c6-8b82d25c073e',
    'd1be2a5b-0049-47b3-9c9b-04cb97d6cd14',
    '2e4bf19e-3018-4df5-935b-236b765cdc2c',
    'c8a8a0d6-ca98-486c-82c3-03d5d32ead86',
    'c2ca5005-4e42-4cc6-9ef9-b17451c998d9',
    '5f7e5180-30ba-46d8-bad8-3ccd3f7261b3',
    '3633a3c7-5b38-49e7-a193-f9fb45d1960d',
    '2170c18f-2d00-4fe1-a4f4-9f5adbaf5cb4',
    '3b02bcda-a183-4737-8294-bc8eec1beafa',
    'cc00265c-24d3-4765-aed0-4a881ee5f0ed',
    '7178e395-2b1c-4145-95d2-c62274d288d7',
    'feec35ca-2b75-422d-934a-5b535ca26440',
    '86b30491-6dd0-46d3-88fa-d73569877464',
    '27bdcdbb-b8e0-413d-9729-cb9b5c229fad',
    '922bff8e-fee3-459d-bea5-d0879c208ad1',
    'ec7f5c0f-4b70-4a16-9f39-88d9c5996acc',
    '6c182d49-d64c-4c7c-b295-9cec0775791e',
    '17ec21c7-291f-40e8-8e18-3bc1bbabda5b',
    'd9956a91-f78a-4506-b552-31f82ec1c2cf',
    'e02359de-cc6b-4689-be4a-a19ed5449cbe',
    '2f449172-9dbe-4a1a-8696-bd36a66a93c1',
    '16acc197-f509-4601-9612-1b0bf31f573e'
  ]
};
